import BaseController from "confinus_ui/base_controller";

// @ts-ignore
import Choices from "choices.js";

export default class ChoicesSelectController extends BaseController {
  public static targets = ["select"];
  public static values = {
    multiple: { type: Boolean, default: false },
  };

  declare private readonly selectTarget: HTMLSelectElement;
  declare private readonly multipleValue: boolean;
  private choicesInstance: any;

  public connect() {
    super.connect();
    const options = this.multipleValue
      ? { removeItemButton: true, searchResultLimit: 8, allowHTML: true }
      : { searchResultLimit: 8 };
    this.choicesInstance = new Choices(this.selectTarget, options);
  }

  public disconnect() {
    if (this.choicesInstance) {
      this.choicesInstance.destroy();
      this.choicesInstance = null;
    }
    super.disconnect();
  }
}
